import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import personService from "services/person/personService";
import { useNotification } from "context/NotificationContext";

const getErrorMessage = (err) => {
    if (err?.response) {
        if (err.response.status === 403) {
            return "You don't have access to this page. Please contact your administrator.";
        }

        if (err.response.status >= 500) {
            return "The server encountered an error.";
        }

        return "Failed to fetch employee list.";
    }

    if (err?.request) {
        return "Unable to reach the server. Please check your connection.";
    }

    return "Failed to load employee list.";
};

export default function usePersonList() {
    const notify = useNotification();

    const query = useQuery({
        queryKey: ["persons"],
        queryFn: async () => {
            const { data } = await personService.list();

            return data ?? [];
        },
        staleTime: 5 * 60 * 1000
    });

    useEffect(() => {
        if (!query.error) {
            return;
        }

        const errorMessage = getErrorMessage(query.error);

        console.error("Error fetching person list:", {
            err: query.error,
            status: query.error?.response?.status
        });

        notify.error(errorMessage);
    }, [query.error, notify]);

    return {
        items: query.data ?? [],
        loading: query.isLoading,
        error: query.error,
        refresh: query.refetch
    };
}
